import React, { useEffect, useState } from "react";
import { Col, Row, Skeleton } from "antd";
import Billingcard from "../../../../../components/dashboardpages/billingcard/billingcard";
import { teacherPricing } from "../../../../../utils/data";
import useCountry from "../../../../../customhooks/usecountry/usecountry";

const Teacherpricing = () => {
  const { isNGN, loadingCountry, countryData } = useCountry();
  const [dataToUse, setDataToUse] = useState<any[]>([]);

  const getAppropriateData = () => {
    let dataToUse: any[] = [];
    if (countryData !== null) {
      dataToUse = [];
    }
    if (isNGN) {
      dataToUse = teacherPricing.filter((item) => item.country === "NGN");
    } else {
      dataToUse = teacherPricing.filter((item) => item.country !== "NGN");
    }
    setDataToUse(dataToUse);
  };

  useEffect(() => {
    getAppropriateData();

    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <p className="mb-10 text-[20px] font-semibold leading-[28px] text-appcolorblack">
        Billing
      </p>

      <div className="bg-appcolorwhite px-5 py-[1.3rem]">
        <Row gutter={32}>
          {loadingCountry || countryData === null ? (
            <>
              {[1, 2, 3, 4, 5].map((item) => (
                <Col
                  lg={24}
                  md={24}
                  xs={24}
                  key={`student-pricing-loader-${item}`}
                >
                  <Skeleton.Button
                    active={true}
                    size={"large"}
                    shape={"square"}
                    block={true}
                    style={{
                      height: "20rem",
                      marginBottom: "1rem",
                      borderRadius: "1rem",
                      marginRight: "1rem",
                      width: "100%",
                    }}
                  />
                </Col>
              ))}
            </>
          ) : (
            dataToUse.map((item, index) => (
              <Col lg={24} md={24} xs={24} key={`student-pricing-${index}`}>
                <Billingcard item={item} isNGN={isNGN} />
              </Col>
            ))
          )}
        </Row>
      </div>
    </div>
  );
};

export default Teacherpricing;
